export default ($resource) => {
    const url = `${SEED_CORE.ENV.API_URL}form/form-submission-answer`;

    return $resource(url, null, {
        batchCreate: {
            method: 'POST',
            url: `${url}/batch-create`
        },
        update: {
            method: 'PUT',
            url: `${url}/:id`
        }
    });
};



// WEBPACK FOOTER //
// ./src/app/resources/FormSubmissionAnswer/index.js